import domain from "@/environment";
import axios from "axios";

const state = {
  systemeChauffages: [],

};

const getters = {
  getAllSystemeChauffages: (state) => state.systemeChauffages,
};

const mutations = {
  PUSH_SYSTEME_CHAUFFAGE(state, payload) {
    state.systemeChauffages.push(payload);
  },
  UPDATE_SYSTEME_CHAUFFAGE(state, payload) {
    const index = state.systemeChauffages.findIndex(
      (sc) => sc.id === payload.id
    );
    if (index !== -1) {
      state.systemeChauffages[index] = {
        ...state.systemeChauffages[index],
        ...payload,
      };
    }
  },

  DELETE_SYSTEME_CHAUFFAGE(state, payload) {
    state.systemeChauffages = state.systemeChauffages.filter(
      (sc) => sc.id !== payload.id
    );
  },
  SET_SYSTEME_CHAUFFAGES(state, payload) {
    state.systemeChauffages = payload || [];
  },
};

const actions = {
  async allSystemeChauffages({ commit }, payload) {
    const params = {
      page: payload.page,
      per_page: payload.per_page,
      search: payload.search,
    };
    try {
      const response = await axios.get(domain + `/systeme-chauffages`, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      commit("SET_SYSTEME_CHAUFFAGES", response.data.data.data);
      
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Une erreur est survenue.";
      return message;
    }
  },

async storeSystemeChauffage({ commit }, payload) {
  try {
    const response = await axios.post(domain + `/systeme-chauffages`, payload, {
      headers: {
        Authorization: `Bearer ` + this.state.token,
      },
    });
    commit("PUSH_SYSTEME_CHAUFFAGE", response.data.data);
    return response.data;
  }  catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    return message;
  }
},
  async editSystemeChauffage({ commit }, payload) {
    try {
      const response = await axios.put(
        domain + `/systeme-chauffages/` + payload.id,
        payload,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      commit("UPDATE_SYSTEME_CHAUFFAGE", response.data.data);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Une erreur est survenue.";
      return message;
    }
  },
  async deleteSystemeChauffage({ commit }, payload) {
    try {
      await axios.delete(domain + `/systeme-chauffages/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_SYSTEME_CHAUFFAGE", payload);
      return true;
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Une erreur est survenue.";
      return message;
    }
  },
};

export default { state, mutations, getters, actions };
